var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.activeModal),callback:function ($$v) {_vm.activeModal=$$v},expression:"activeModal"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.title))]),_c('v-spacer'),_c('v-icon',{on:{"click":_vm.close}},[_vm._v("mdi-close")])],1),_c('v-card-text',{staticClass:"text-right"},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.salvarPpag.apply(null, arguments)}}},[_c('TextField',{attrs:{"rules":[(v) => !!v || `Preencha o campo corretamente`],"title":"Código do PPAG","id":"codigo_ppag","vModel":_vm.ppag.codigo_ppag,"responsive":{
        lg: 12,
        md: 12,
        sm: 12,
        cols: 12,
    }},on:{"input":function($event){_vm.ppag.codigo_ppag = $event}}}),_vm._v(" "+_vm._s(_vm.ppag.valor)+" "),_c('TextField',{attrs:{"rules":[(v) => !!v || `Preencha o campo corretamente`],"mask":"################","title":"Valor","id":"valor","vModel":_vm.ppag.valor,"responsive":{
        lg: 12,
        md: 12,
        sm: 12,
        cols: 12,
    }},on:{"input":function($event){_vm.ppag.valor = $event}}}),_c('TextField',{attrs:{"rules":[(v) => !!v || `Preencha o campo corretamente`],"title":"Gerência","id":"gerencia","vModel":_vm.ppag.gerencia,"responsive":{
        lg: 12,
        md: 12,
        sm: 12,
        cols: 12,
    }},on:{"input":function($event){_vm.ppag.gerencia = $event}}}),_c('SelectField',{attrs:{"title":"Exercício","id":"exercicio","vModel":_vm.ppag.exercicio,"options":_vm.exerciciosOptions,"rules":[(v) => !!v || 'Campo obrigatório não informado.'],"responsive":{
        lg: 12,
        md: 12,
        sm: 12,
        cols: 12,
    }},on:{"input":function($event){_vm.ppag.exercicio = $event}}}),_c('SelectField',{attrs:{"title":"Ação","id":"acao","vModel":_vm.ppag.acao_id,"options":_vm.acoesOptions,"rules":[(v) => !!v || 'Campo obrigatório não informado.'],"responsive":{
        lg: 12,
        md: 12,
        sm: 12,
        cols: 12,
    }},on:{"input":function($event){_vm.ppag.acao_id = $event}}}),_c('SelectField',{attrs:{"title":"Seção","id":"secao","vModel":_vm.ppag.secao_id,"options":_vm.secoesOptions,"rules":[(v) => !!v || 'Campo obrigatório não informado.'],"responsive":{
        lg: 12,
        md: 12,
        sm: 12,
        cols: 12,
    }},on:{"input":function($event){_vm.ppag.secao_id = $event}}}),_c('SelectField',{attrs:{"title":"Grupo","id":"grupo","vModel":_vm.ppag.grupo_id,"options":_vm.gruposOptions,"rules":[(v) => !!v || 'Campo obrigatório não informado.'],"responsive":{
        lg: 12,
        md: 12,
        sm: 12,
        cols: 12,
    }},on:{"input":function($event){_vm.ppag.grupo_id = $event}}}),_c('SelectField',{attrs:{"title":"IPG","id":"ipg","vModel":_vm.ppag.ipg_id,"options":_vm.ipgsOptions,"rules":[(v) => !!v || 'Campo obrigatório não informado.'],"responsive":{
        lg: 12,
        md: 12,
        sm: 12,
        cols: 12,
    }},on:{"input":function($event){_vm.ppag.ipg_id = $event}}}),_c('SelectField',{attrs:{"title":"IPU","id":"ipu","vModel":_vm.ppag.ipu_id,"options":_vm.ipusOptions,"rules":[(v) => !!v || 'Campo obrigatório não informado.'],"responsive":{
        lg: 12,
        md: 12,
        sm: 12,
        cols: 12,
    }},on:{"input":function($event){_vm.ppag.ipu_id = $event}}}),_c('SelectField',{attrs:{"title":"El. Item","id":"elemento_item","vModel":_vm.ppag.elemento_item_id,"options":_vm.elementosItensOptions,"rules":[(v) => !!v || 'Campo obrigatório não informado.'],"responsive":{
        lg: 12,
        md: 12,
        sm: 12,
        cols: 12,
    }},on:{"input":function($event){_vm.ppag.elemento_item_id = $event}}}),_c('TextAreaField',{attrs:{"title":"Detalhamento","id":"detalhamento","vModel":_vm.ppag.detalhamento},on:{"input":function($event){_vm.ppag.detalhamento = $event}}}),_c('v-checkbox',{attrs:{"label":"Ativo"},model:{value:(_vm.ppag.ativo),callback:function ($$v) {_vm.$set(_vm.ppag, "ativo", $$v)},expression:"ppag.ativo"}}),_c('v-btn',{attrs:{"loading":_vm.loading,"type":"submit","color":"primary","disabled":_vm.loading}},[(!_vm.loading)?_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-content-save")]):_c('v-icon',[_vm._v("mdi-loading")]),_vm._v(" Salvar ")],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }